import { FastField, Field, FieldProps } from 'formik';
import { Controller, useFormContext } from 'react-hook-form';
import { Form, Checkbox } from 'antd';
import React, { ReactNode } from 'react';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

type FormCheckboxProps = {
  name: string;
  label?: string | ReactNode;
  checkedValue?: number;
  disabled?: boolean;
  className?: string;
  fastField?: boolean;
  content?: string | ReactNode;
  handleChange?: (e: CheckboxChangeEvent) => void;
  useHookForm?: boolean;
};

const FormCheckbox: React.FC<FormCheckboxProps> = props => {
  const {
    name,
    label,
    checkedValue,
    disabled,
    className,
    fastField,
    content,
    handleChange,
    useHookForm,
  } = props;
  const { control } = useFormContext() || {};

  if (useHookForm) {
    return (
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <Form.Item
            label={label}
            className={className}
            validateStatus={error ? 'error' : ''}
            help={error?.message || undefined}
          >
            <Checkbox
              name={name}
              disabled={disabled}
              checked={checkedValue ? field.value === checkedValue : field.value}
              onChange={handleChange || field.onChange}
            >
              {content}
            </Checkbox>
          </Form.Item>
        )}
      />
    );
  }

  const fieldContent = ({ field }: FieldProps) => {
    return (
      <Form.Item label={label} className={className}>
        <Checkbox
          name={name}
          disabled={disabled}
          checked={checkedValue ? field.value === checkedValue : field.value}
          onChange={handleChange || field.onChange}
        >
          {content}
        </Checkbox>
      </Form.Item>
    );
  };

  return fastField ? (
    <FastField name={name}>{fieldContent}</FastField>
  ) : (
    <Field name={name}>{fieldContent}</Field>
  );
};

export default FormCheckbox;
